var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-menu-layout',[_c('row',[_c('col12',[_c('manage-label-sets')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }